import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class DeliverableComment extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "deliverable-comment";
    static pluralName = "deliverable-comments";
    static displayName = "DeliverableComment";

    constructor() {
        super(`${DeliverableComment.kind}`, `${DeliverableComment.singularName}`, `${DeliverableComment.pluralName}`);
    }

    async getAll(query = {}) {
        const qs = require("qs");
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true,
        });

        return await this.fetch(_query);
    }

    async getById(id, query = {}) {
        return await this.find(id, {populate: "*", ...query});
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }
}
